import React from "react";
import { MDBIcon, MDBBtn, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import './style.css';
import dataServizi from '../../servizi/data/output';

export default function MettitiInContatto() {

    const location_origin = typeof window !== "undefined" ? `${window.location.origin.toString()}/` : `https://www.notaio-treviso.com/`

	return (
		<MDBRow className="text-center">
            <MDBRow className='text-center customRow'>
                <a 
                title={`Via Cornarotta 5 Treviso | Studio Notarile Falcinelli | Notaio a Treviso`} 
                href="https://goo.gl/maps/cjzqhqb31f4Spurg7"
                target="_blank"
                className='aColor'
                >
                <i className='fas fa-home me-3'></i> 
                Via Cornarotta n.5, Treviso
                </a>
            </MDBRow>

            <MDBRow className='text-center customRow'>
                <a
                title={`Mail Studio Notarile Falcinelli | Notaio a Treviso`}
                href="mailto:info@notaiofalcinelli.it"
                target="_blank"
                className='aColor'
                >
                <i className='fas fa-envelope me-3'></i>
                info@notaiofalcinelli.it
                </a>
            </MDBRow>

            <MDBRow className='text-center customRow'>
                <a
                title={`Telefono Studio Notarile Falcinelli | Notaio a Treviso`} 
                href="tel:+3904221628653"
                target="_blank"
                className='aColor'
                >
                <i className='fas fa-phone me-3'></i> 
                +39 04221628653
                </a>
            </MDBRow>

            <MDBRow className='text-center customRow'>
                <a
                title={`WhatsApp Studio Notarile Falcinelli | Notaio a Treviso`} 
                href='https://api.whatsapp.com/send/?phone=3904221628653'
                target="_blank"
                className='aColor'
                >
                <i className="fa fa-whatsapp me-3" style={{color: '#22ad10'}}></i>
                    WhatsApp Studio Notarile Falcinelli
                </a>
            </MDBRow>
        
            <MDBRow className='text-center customRow'>
                <p>Richiedi Preventivo al Notaio a Treviso per il tuo Atto Notarile di compravendita e mutuo. Compila tutti i dati richiesti dal nostro ufficio.</p>
                <p>I campi con asterisco (*) sono obbligatori.</p>
                <p>Per qualsiasi richiesta dedicata non esitate a contattarci al nostro numero telefonico <a
                title={`Telefono Studio Notarile Falcinelli | Notaio a Treviso`} 
                href="tel:+3904221628653"
                target="_blank"
                className='aColor'
                >+39 04221628653
                </a></p>
            </MDBRow>

            <MDBRow className='text-center customRow'>
                <p><strong>Altre Richieste</strong></p>
                <MDBCol sm='12' center className='col-example'>
                    <MDBBtn
                        href={`${location_origin}preventivo`}
                        size="sm"
                        outline color="primary" className='m-1'>
                        Preventivo
                    </MDBBtn>
                </MDBCol>
                <MDBCol sm='12' center className='col-example'>
                    <MDBBtn
                        href={`${location_origin}copia-atti`}
                        size="sm"
                        outline color="primary" className='m-1'>
                        Copia Atti
                    </MDBBtn>
                </MDBCol>
                <MDBCol sm='12' center className='col-example'>
                    <MDBBtn
                        href={`${location_origin}consulenza`}
                        size="sm"
                        outline color="primary" className='m-1'>
                        Consulenza
                    </MDBBtn>
                </MDBCol>
                <MDBCol sm='12' center className='col-example'>
                    <MDBBtn
                        href={`${location_origin}videoconferenza`}
                        size="sm"
                        outline color="primary" className='m-1'>
                        Videoconferenza
                    </MDBBtn>
                </MDBCol>
            </MDBRow>

            <MDBRow className='text-center customRow'>
                <p><strong>Servizi</strong></p>
                {dataServizi.map(item => {
                    return (
                            <MDBBtn
                                size="sm"
                                href={`${location_origin}servizi/${item.link}`}
                                outline color="info" 
                                className='m-1'
                                style={{width:'fit-content'}}>
                                {item.name}
                            </MDBBtn>
                    )
                })}
            </MDBRow>
            
            <MDBRow center className='text-center customRow'>
                <MDBRow center>
                        <MDBBtn className='m-1' style={{ width:'fit-content', backgroundColor: '#3b5998' }} target="_blank" href='https://www.facebook.com/Notaio-Treviso-Studio-Notarile-Falcinelli-108508261876163/'>
                            <MDBIcon fab icon='facebook-f' />
                        </MDBBtn>
                        <MDBBtn className='m-1' style={{ width:'fit-content', backgroundColor: '#dd4b39' }} target="_blank" href='https://notaiotreviso.business.site/'>
                            <MDBIcon fab icon='google' />
                        </MDBBtn>
                        <MDBBtn className='m-1' style={{ width:'fit-content', backgroundColor: '#ac2bac' }} target="_blank" href='https://www.instagram.com/notaiotreviso/'>
                            <MDBIcon fab icon='instagram' />
                        </MDBBtn>
                </MDBRow>
                <MDBRow center>
                        <MDBBtn className='m-1' style={{ width:'fit-content', backgroundColor: '#0082ca' }} target="_blank" href='https://www.linkedin.com/company/notaio-treviso-studio-notarile-falcinelli/'>
                            <MDBIcon fab icon='linkedin-in' />
                        </MDBBtn>

                        <MDBBtn className='m-1' style={{ width:'fit-content', backgroundColor: '#ed302f' }} target="_blank" href='https://www.youtube.com/channel/UCe-V7fjNLFSxcrMCrW_FTNA/featured'>
                            <MDBIcon fab icon='youtube' />
                        </MDBBtn>
                        <MDBBtn className='m-1' style={{ width:'fit-content', backgroundColor: '#25d366' }} target="_blank" href='https://api.whatsapp.com/send/?phone=3904221628653'>
                            <MDBIcon fab icon='whatsapp' />
                        </MDBBtn>
                </MDBRow>
            </MDBRow>
        </MDBRow>
	);
}